import { useMutationWithToast } from '@/hooks/useQueryWithToast';
import { supabase } from '@/integrations/supabase/client';

export interface DeleteCopiedDataOptions {
  projectId: string;
  batchId?: string | null;
  deleteItems: boolean;
  deleteSpecs: boolean;
  deleteDrawings: boolean;
}

export interface DeleteCopiedDataResult {
  success: boolean;
  items_deleted?: number;
  specs_deleted?: number;
  drawings_deleted?: number;
  error?: string;
}

export function useDeleteCopiedProjectData() {
  return useMutationWithToast<DeleteCopiedDataResult, DeleteCopiedDataOptions>({
    mutationFn: async (options): Promise<DeleteCopiedDataResult> => {
      const { data, error } = await supabase.rpc('delete_copied_project_data', {
        p_project_id: options.projectId,
        p_batch_id: options.batchId || null,
        p_delete_items: options.deleteItems,
        p_delete_specs: options.deleteSpecs,
        p_delete_drawings: options.deleteDrawings,
      });
      
      if (error) throw error;
      
      const result = data as unknown as DeleteCopiedDataResult;
      if (!result.success) {
        throw new Error(result.error || 'Delete failed');
      }
      
      return result;
    },
    successMessage: 'Đã xóa dữ liệu thành công',
    errorMessage: 'Lỗi khi xóa dữ liệu',
    invalidateQueries: [
      ['specs-data'],
      ['optimized-specs-data'],
      ['specs-layers'],
      ['specs-pins'],
      ['diary-pins'],
      ['items-optimized'],
      ['items'],
      ['project-items'],
      ['drawings'],
    ],
  });
}
